<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item label="统计月份">
                <a-month-picker v-model="queryParam.month" placeholder="请选择月份" format="YYYY-MM" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="门店名称">
                <a-input v-model="queryParam.storeName" placeholder="请输入门店名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="商家名称">
                <a-input v-model="queryParam.merchantName" placeholder="请输入商家名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="结算状态">
                <a-select v-model="queryParam.settleStatus" placeholder="请选择结算状态" allow-clear style="width: 100%">
                  <a-select-option :value="0">未结算</a-select-option>
                  <a-select-option :value="1">已结算</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="filteredColumns"
        :data-source="list"
        :pagination="pagination"
        :bordered="tableBordered"
        @change="handleTableChange"
      >
        <span slot="storeId" slot-scope="text">
          <a-tag color="blue">{{ text }}</a-tag>
        </span>
        <span slot="merchantId" slot-scope="text">
          <a-tag color="cyan">{{ text }}</a-tag>
        </span>
        <span slot="storeTotalAmount" slot-scope="text">
          <a-tag v-if="text" color="green">¥{{ parseFloat(text).toFixed(2) }}</a-tag>
        </span>
        <span slot="platformTotalAmount" slot-scope="text">
          <a-tag v-if="text" color="purple">¥{{ parseFloat(text).toFixed(2) }}</a-tag>
        </span>
        <span slot="merchantTotalAmount" slot-scope="text">
          <a-tag v-if="text" color="orange">¥{{ parseFloat(text).toFixed(2) }}</a-tag>
        </span>
        <span slot="orderCount" slot-scope="text">
          <a-tag color="blue">{{ text }}</a-tag>
        </span>
        <span slot="settleStatus" slot-scope="text">
          <a-tag :style="{ backgroundColor: text === 1 ? '#52c41a' : '#faad14', color: '#fff' }">{{ text === 1 ? '已结算' : '未结算' }}</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical" />
          <a v-if="record.settleStatus === 0" @click="handleSettle(record)">结算</a>
          <span v-else style="color: #ccc">已结算</span>
        </span>
      </a-table>
    </a-card>

    <!-- 详情弹窗 -->
    <a-modal
      title="门店要货统计详情"
      :visible="detailVisible"
      :footer="null"
      @cancel="handleCloseDetail"
      width="800px"
    >
      <a-descriptions bordered :column="2" v-if="detailInfo">
        <a-descriptions-item label="门店ID">{{ detailInfo.storeId }}</a-descriptions-item>
        <a-descriptions-item label="门店名称">{{ detailInfo.storeName }}</a-descriptions-item>
        <a-descriptions-item label="所属商家ID">{{ detailInfo.merchantId }}</a-descriptions-item>
        <a-descriptions-item label="所属商家名称">{{ detailInfo.merchantName }}</a-descriptions-item>
        <a-descriptions-item label="统计月份">{{ detailInfo.month }}</a-descriptions-item>
        <a-descriptions-item label="订单数量">{{ detailInfo.orderCount }}</a-descriptions-item>
        <a-descriptions-item v-if="detailInfo.storeTotalAmount" label="门店拿货总金额">¥{{ parseFloat(detailInfo.storeTotalAmount).toFixed(2) }}</a-descriptions-item>
        <a-descriptions-item v-if="detailInfo.platformTotalAmount" label="平台成本总金额">¥{{ parseFloat(detailInfo.platformTotalAmount).toFixed(2) }}</a-descriptions-item>
        <a-descriptions-item v-if="detailInfo.merchantTotalAmount" label="商家拿货总金额">¥{{ parseFloat(detailInfo.merchantTotalAmount).toFixed(2) }}</a-descriptions-item>
        <a-descriptions-item label="结算状态">
          <a-tag :style="{ backgroundColor: detailInfo.settleStatus === 1 ? '#52c41a' : '#faad14', color: '#fff' }">{{ detailInfo.settleStatusName }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="结算时间">{{ detailInfo.settleTime || '-' }}</a-descriptions-item>
        <a-descriptions-item label="结算人">{{ detailInfo.settleUserName || '-' }}</a-descriptions-item>
      </a-descriptions>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { getStorePurchaseStatistics, getStorePurchaseStatisticsDetail, settleStorePurchaseStatistics } from '@/api/statistics/storePurchase'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

export default {
  name: 'StorePurchaseStatistics',
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      detailVisible: false,
      detailInfo: null,
      queryParam: {
        month: undefined,
        storeName: undefined,
        merchantId: undefined,
        merchantName: undefined,
        settleStatus: undefined,
        current: 1,
        size: 10
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        {
          title: '门店ID',
          dataIndex: 'storeId',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'storeId' }
        },
        {
          title: '门店名称',
          dataIndex: 'storeName',
          width: 150,
          align: 'center'
        },
        {
          title: '所属商家ID',
          dataIndex: 'merchantId',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'merchantId' }
        },
        {
          title: '所属商家名称',
          dataIndex: 'merchantName',
          width: 150,
          align: 'center'
        },
        {
          title: '统计月份',
          dataIndex: 'month',
          width: 100,
          align: 'center'
        },
        {
          title: '门店拿货总金额(元)',
          dataIndex: 'storeTotalAmount',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'storeTotalAmount' }
        },
        {
          title: '平台成本总金额(元)',
          dataIndex: 'platformTotalAmount',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'platformTotalAmount' }
        },
        {
          title: '商家拿货总金额(元)',
          dataIndex: 'merchantTotalAmount',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'merchantTotalAmount' }
        },
        {
          title: '订单数量',
          dataIndex: 'orderCount',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'orderCount' }
        },
        {
          title: '结算状态',
          dataIndex: 'settleStatus',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'settleStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    // 默认查询当前月份
    this.queryParam.month = moment()
    this.getList()
  },
  computed: {
    filteredColumns() {
      // 检查是否有数据且至少有一条记录
      if (!this.list || this.list.length === 0) {
        return this.columns
      }

      // 获取第一条记录,检查哪些字段有值
      const firstRecord = this.list[0]

      return this.columns.filter(col => {
        // 平台成本总金额列
        if (col.dataIndex === 'platformTotalAmount') {
          return firstRecord.platformTotalAmount !== null && firstRecord.platformTotalAmount !== undefined
        }
        // 商家拿货总金额列
        if (col.dataIndex === 'merchantTotalAmount') {
          return firstRecord.merchantTotalAmount !== null && firstRecord.merchantTotalAmount !== undefined
        }
        // 其他列保持显示
        return true
      })
    }
  },
  methods: {
    moment,
    getList() {
      this.loading = true
      const params = {
        pageNo: this.queryParam.current,
        pageSize: this.queryParam.size
      }

      if (this.queryParam.month) {
        params.month = moment(this.queryParam.month).format('YYYY-MM')
      }

      if (this.queryParam.storeName) {
        params.storeName = this.queryParam.storeName
      }

      if (this.queryParam.merchantName) {
        params.merchantName = this.queryParam.merchantName
      }

      if (this.queryParam.settleStatus !== undefined && this.queryParam.settleStatus !== '') {
        params.settleStatus = this.queryParam.settleStatus
      }

      getStorePurchaseStatistics(params).then(response => {
        this.list = response.data?.records || []
        this.pagination.total = response.data?.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleTableChange(pagination, filters, sorter) {
      this.queryParam.current = pagination.current
      this.queryParam.size = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize

      this.getList()
    },
    handleQuery() {
      this.queryParam.current = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        month: moment(),
        storeId: undefined,
        merchantId: undefined,
        settleStatus: undefined,
        current: 1,
        size: 10
      }
      this.getList()
    },
    handleDetail(record) {
      this.loading = true
      getStorePurchaseStatisticsDetail({ id: record.id }).then(response => {
        this.detailInfo = response.data
        this.detailVisible = true
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleCloseDetail() {
      this.detailVisible = false
      this.detailInfo = null
    },
    handleSettle(record) {
      this.$confirm({
        title: '确认结算',
        content: `确定要结算 ${record.storeName} ${record.month} 的要货统计吗？`,
        onOk: () => {
          this.loading = true
          settleStorePurchaseStatistics({ id: record.id }).then(() => {
            this.$message.success('结算成功')
            this.getList()
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}
</style>
